import Modal from '@anwb/poncho/components/modal';
import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled from 'styled-components';

import { getEquipmentModalABTest } from '../../../../utils/getEquipmentModalABTest';

export const DescriptionListContainer = styled.div`
	margin-bottom: ${({ theme }) => (getEquipmentModalABTest() ? 0 : pxToRem(theme.spacing['400']))};
`;

export const SpecAndEditLinkContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const StyledModal = styled(Modal)`
	& .PONCHO-modal__footer {
		margin-top: 1rem;
	}
`;
